import * as types from "../../actionType";

const initialState = {
  archivedBrandsList: [],
  archivedBrandsCount: 0,
  archivedBrandsSeasons: [],
  archivedBrandsLoader: false,
  archivedBrandStyles: {},
  archivedBrandStylesLoader: false,
};

export const ArchivedBrandsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ARCHIVED_BRANDS_LIST_LOADING:
      return {
        ...state,
        archivedBrandsLoader: true,
      };
    case types.ARCHIVED_BRANDS_LIST_SUCCESS:
      return {
        ...state,
        archivedBrandsList: action.payload?.brands || [],
        archivedBrandsCount: action.payload?.total_brands || 0,
        archivedBrandsSeasons: action.payload?.seasons || [],
        archivedBrandsLoader: false,
      };
    case types.ARCHIVED_BRANDS_LIST_FAIL:
      return {
        ...state,
        archivedBrandsList: [],
        archivedBrandsCount: 0,
        archivedBrandsLoader: false,
      };
    case types.ARCHIVED_BRAND_STYLES_LOADING:
      return {
        ...state,
        archivedBrandStylesLoader: true,
      };
    case types.ARCHIVED_BRAND_STYLES_SUCCESS:
      return {
        ...state,
        archivedBrandStyles: action.payload || {},
        archivedBrandStylesLoader: false,
      };
    case types.ARCHIVED_BRAND_STYLES_FAIL:
      return {
        ...state,
        archivedBrandStyles: {},
        archivedBrandStylesLoader: false,
      };
    default:
      return state;
  }
};
